import defaultCardImg from '../../../assets/images/defaultCardImg.jpg';
import { closePopup } from '../../../store/slices/popupSlice';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import styles from './styles/styles.module.css';

function OpenPicPopup() {
  const dispatch = useAppDispatch();
  const image = useAppSelector((state) => state.stocks.selectImg);

  const handleClosePopup = () => {
    dispatch(closePopup());
  };

  return (
    <div className={styles.failPopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <img
        className={styles.cardItemImg}
        src={image || defaultCardImg}
        onError={(e) => {
          e.target.src = defaultCardImg;
        }}
      />
    </div>
  );
}

export default OpenPicPopup;
